import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ExplorerAsideSection, UiComponentName, useComponentProps } from '@shapeable/ui';
import { TrendsNavigatorMap } from '../elements/trends-navigator-map';

const cls = classNames('slice-explorer-map');

// -------- Types -------->

// -------- Props -------->

export type SliceExplorerMapSidebarProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceExplorerMapSidebarDefaultProps: Omit<SliceExplorerMapSidebarProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const MapStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  NAME: 'SliceExplorerMapSidebar' as UiComponentName,

  Container: styled(ExplorerAsideSection)<ContainerProps>`${ContainerStyles}`,
    Map: styled(TrendsNavigatorMap)`${MapStyles}`,
};

export const SliceExplorerMapSidebar: Shapeable.FC<SliceExplorerMapSidebarProps> = (props) => {
  const { className, children, entity } = useComponentProps(My.NAME, SliceExplorerMapSidebarDefaultProps, props);
  // const defn = useSliceConnections(entity);

  return (
    <My.Container className={cls.name(className)}>
      <My.Map />
    </My.Container>
  )
};

SliceExplorerMapSidebar.cls = cls;